import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import apiService from '../../services/apiService';
import Button from '../ui/Button';

const ApiTest = () => {
    const { loading, error } = useApp();
    const [testResults, setTestResults] = useState({});
    const [isVisible, setIsVisible] = useState(false);

    const runTest = async (testName, testFunction) => {
        try {
            setTestResults(prev => ({
                ...prev,
                [testName]: { status: 'running', message: 'Ejecutando...' }
            }));

            const result = await testFunction();

            setTestResults(prev => ({
                ...prev,
                [testName]: {
                    status: result.success ? 'success' : 'error',
                    message: result.message || 'Test completado',
                    data: result.data
                }
            }));
        } catch (error) {
            setTestResults(prev => ({
                ...prev,
                [testName]: {
                    status: 'error',
                    message: error.message || 'Error en el test'
                }
            }));
        }
    };

    const testApiConnection = async () => {
        const result = await apiService.checkApiStatus();
        return {
            success: !!result,
            message: result ? 'API conectada correctamente' : 'Error de conexión',
            data: result
        };
    };

    const testLogin = async () => {
        const result = await apiService.login('admin', 'admin123');
        return {
            success: result.success,
            message: result.message,
            data: result.data
        };
    };

    const testProducts = async () => {
        const result = await apiService.getProductos();
        return {
            success: result.success,
            message: result.message,
            data: result.data
        };
    };

    const testCategories = async () => {
        const result = await apiService.getCategorias();
        return {
            success: result.success,
            message: result.message,
            data: result.data
        };
    };

    const runAllTests = async () => {
        await runTest('connection', testApiConnection);
        await runTest('login', testLogin);
        await runTest('products', testProducts);
        await runTest('categories', testCategories);
    };

    const getStatusIcon = (status) => {
        switch (status) {
            case 'running': return '⏳';
            case 'success': return '✅';
            case 'error': return '❌';
            default: return '⚪';
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'running': return '#ffa500';
            case 'success': return '#28a745';
            case 'error': return '#dc3545';
            default: return '#6c757d';
        }
    };

    if (!isVisible) {
        return (
            <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000 }}>
                <Button
                    onClick={() => setIsVisible(true)}
                    style={{
                        background: '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '50%',
                        width: '50px',
                        height: '50px',
                        fontSize: '20px'
                    }}
                >
                    🔧
                </Button>
            </div>
        );
    }

    return (
        <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            width: '400px',
            background: 'white',
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 1000,
            maxHeight: '80vh',
            overflow: 'auto'
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h3 style={{ margin: 0, fontSize: '18px' }}>🔧 API Test Panel</h3>
                <button
                    onClick={() => setIsVisible(false)}
                    style={{
                        background: 'none',
                        border: 'none',
                        fontSize: '20px',
                        cursor: 'pointer'
                    }}
                >
                    ✖️
                </button>
            </div>

            <div style={{ marginBottom: '20px' }}>
                <Button
                    onClick={runAllTests}
                    disabled={loading}
                    style={{ width: '100%', marginBottom: '10px' }}
                >
                    Ejecutar Todos los Tests
                </Button>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                    <Button
                        onClick={() => runTest('connection', testApiConnection)}
                        disabled={loading}
                        size="small"
                    >
                        Test Conexión
                    </Button>

                    <Button
                        onClick={() => runTest('login', testLogin)}
                        disabled={loading}
                        size="small"
                    >
                        Test Login
                    </Button>

                    <Button
                        onClick={() => runTest('products', testProducts)}
                        disabled={loading}
                        size="small"
                    >
                        Test Productos
                    </Button>

                    <Button
                        onClick={() => runTest('categories', testCategories)}
                        disabled={loading}
                        size="small"
                    >
                        Test Categorías
                    </Button>
                </div>
            </div>

            <div style={{ borderTop: '1px solid #eee', paddingTop: '15px' }}>
                <h4 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#666' }}>Resultados:</h4>

                {Object.keys(testResults).length === 0 && (
                    <p style={{ color: '#666', fontStyle: 'italic' }}>
                        No se han ejecutado tests aún
                    </p>
                )}

                {Object.entries(testResults).map(([testName, result]) => (
                    <div
                        key={testName}
                        style={{
                            padding: '10px',
                            marginBottom: '10px',
                            borderRadius: '4px',
                            border: `1px solid ${getStatusColor(result.status)}`,
                            backgroundColor: `${getStatusColor(result.status)}15`
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                            <span style={{ marginRight: '8px' }}>
                                {getStatusIcon(result.status)}
                            </span>
                            <strong style={{ textTransform: 'capitalize' }}>
                                {testName}
                            </strong>
                        </div>

                        <div style={{ fontSize: '12px', color: '#666' }}>
                            {result.message}
                        </div>

                        {result.data && (
                            <details style={{ marginTop: '8px' }}>
                                <summary style={{ fontSize: '11px', cursor: 'pointer', color: '#007bff' }}>
                                    Ver datos
                                </summary>
                                <pre style={{
                                    fontSize: '10px',
                                    background: '#f8f9fa',
                                    padding: '8px',
                                    borderRadius: '4px',
                                    marginTop: '5px',
                                    overflow: 'auto',
                                    maxHeight: '150px'
                                }}>
                                    {JSON.stringify(result.data, null, 2)}
                                </pre>
                            </details>
                        )}
                    </div>
                ))}
            </div>

            {error && (
                <div style={{
                    marginTop: '15px',
                    padding: '10px',
                    background: '#f8d7da',
                    border: '1px solid #f5c6cb',
                    borderRadius: '4px',
                    color: '#721c24'
                }}>
                    <strong>Error:</strong> {error}
                </div>
            )}
        </div>
    );
};

export default ApiTest;